import { render, staticRenderFns } from "./channel-line-card.vue?vue&type=template&id=3db9db5d&scoped=true&"
import script from "./channel-line-card.vue?vue&type=script&lang=js&"
export * from "./channel-line-card.vue?vue&type=script&lang=js&"
import style0 from "./channel-line-card.vue?vue&type=style&index=0&id=3db9db5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db9db5d",
  null
  
)

export default component.exports